import script from "./MyTestimonialEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./MyTestimonialEditor.vue?vue&type=script&setup=true&lang=js"

import "./MyTestimonialEditor.vue?vue&type=style&index=0&id=4c407932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c407932"]])

export default __exports__